import React from 'react'

import { DndContext } from '@dnd-kit/core'

import { AppSettingsPage } from 'features/AppSettings/AppSettingsPage'
import { AddCustomPageButton } from 'features/workspace/AddCustomPageButton/AddCustomPageButton'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import { Body } from 'ui/components/Text'

import { useNavigationEditorState } from './hooks/useNavigationEditorState'
import { NAVIGATION_ROOT_DROP_ID } from './constants'
import { NavigationEditorItemList } from './NavigationEditorItemList'

export const NavigationEditor = () => {
    const {
        menuItems,
        homepageItemSid,
        sensors,
        handleDragStart,
        handleDragEnd,
        handleDragOver,
        handleDragCancel,
        isDragging,
        collisionDetection,
        handleKeyDown,
        isEmpty,
        createSeparator,
        editingItemId,
        setEditingItemId,
    } = useNavigationEditorState()

    return (
        <AppSettingsPage
            title="Navigation"
            onKeyDown={handleKeyDown}
            cursor={isDragging ? 'grabbing' : undefined}
            actions={
                <>
                    <Button
                        size="s"
                        variant="secondary"
                        startIcon={{ name: 'SplitSquareVertical' }}
                        onClick={createSeparator}
                    >
                        Add separator
                    </Button>
                    <AddCustomPageButton size="s" startIcon={{ name: 'StickyNote' }} />
                </>
            }
        >
            {isEmpty ? (
                <Box center height="full" width="full" py="xl">
                    <Body size="m" color="textWeaker">
                        No items to display
                    </Body>
                </Box>
            ) : (
                <DndContext
                    sensors={sensors}
                    collisionDetection={collisionDetection}
                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}
                    onDragOver={handleDragOver}
                    onDragCancel={handleDragCancel}
                    autoScroll={{
                        acceleration: 5,
                        // Disable horizontal auto-scrolling.
                        threshold: { x: 0, y: 0.2 },
                        layoutShiftCompensation: false,
                    }}
                >
                    <NavigationEditorItemList
                        items={menuItems}
                        homepageItemSid={homepageItemSid}
                        droppableId={NAVIGATION_ROOT_DROP_ID}
                        isDragging={isDragging}
                        editingItemId={editingItemId}
                        setEditingItemId={setEditingItemId}
                    />
                </DndContext>
            )}
        </AppSettingsPage>
    )
}
